import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "ma-4" }

export function render(_ctx, _cache) {
  const _component_v_card = _resolveComponent("v-card")

  return (_openBlock(), _createBlock(_component_v_card, {
    variant: "outlined",
    width: "870"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", { src: _ctx.logo }, null, 8, _hoisted_2),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header-text" }, "International Feedback Management", -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "footer" }, null, -1))
    ]),
    _: 3
  }))
}